<template>
  <div>
    <div class="subHead">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">考勤记录</span>
    </div>
    <div class="attendanceRecord">
      <div class="container">
        <date-picker
            v-model="date"
            mode="multiple"
            is-inline
            is-expanded
            :from-date="fromDate"
            :attributes="attendances"
            class="vc-container"
            @dayclick="dayclick"
            @update:from-page="fromPage"
            @update:to-page="toPage"
        />
      </div>
      <div class="content">
        <div class="line">
          <div class="item">
            <div class="up">
              <div class="value">{{ workData.workDay }}</div>
              <div class="tips">天</div>
            </div>
            <div class="down">
              出勤
            </div>
          </div>
          <div class="item">
            <div class="up">
              <div class="value">{{ workData.absenteeism }}</div>
              <div class="tips">次</div>
            </div>
            <div class="down">
              旷工
            </div>
          </div>
          <div class="item">
            <div class="up">
              <div class="value">{{ workData.late }}</div>
              <div class="tips">次</div>
            </div>
            <div class="down">
              迟到
            </div>
          </div>
          <div class="item">
            <div class="up">
              <div class="value">{{ workData.lost }}</div>
              <div class="tips">次</div>
            </div>
            <div class="down">
              缺卡
            </div>
          </div>
        </div>
        <div class="line">
          <div class="item">
            <div class="up">
              <div class="value">{{ workData.early }}</div>
              <div class="tips">次</div>
            </div>
            <div class="down">
              早退
            </div>
          </div>
          <div class="item">
            <div class="up">
              <div class="value">{{ workData.askForTime }}</div>
              <div class="tips">分</div>
            </div>
            <div class="down">
              请假
            </div>
          </div>
          <div class="item">
            <div class="up">
              <div class="value">{{ workData.overtime }}</div>
              <div class="tips">分</div>
            </div>
            <div class="down">
              加班
            </div>
          </div>
          <div class="item">
            <div class="up">
              <div class="value">{{ workData.workTime }}</div>
              <div class="tips">分</div>
            </div>
            <div class="down">
              工时
            </div>
          </div>
        </div>
        <div v-if="dayInfo.logDate" class="rule">
          <div class="value">
            考勤规则：{{ dayInfo.ruleDesc }}
          </div>
          <div class="value" style="margin-top: 0.08rem">
            共{{ dayInfo.times }}次卡，工时{{ dayInfo.standardWorkTime }}分钟
          </div>
        </div>
        <div v-if="dayInfo.infos" class="details">
          <div
            v-for="(son, index) in dayInfo.infos"
            class="part"
            :style="index === dayInfo.infos.length - 1 ? '' : 'border-left: 1px solid #efeff4;'"
          >
            <div class="circleOut">
              <div class="circleIn" />
            </div>
            <div class="info">
              <div class="header1">
                <div>{{ son.attendanceTime || '未打卡' }}{{ son.workTypeName }}</div>
                <div :class="son.eventType | formatStatus">{{ son.eventTypeName }}</div>
              </div>
              <div v-if="son.attendanceTime" class="way">
                <svg-icon icon-class="location" />
                {{ son.edificeName }}{{ son.floorName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'v-calendar';
import { attendanceList } from '@/api/user';
import moment from 'moment';
import { Step, Steps } from 'vant';

export default {
  name: 'AttendanceRecord',
  components: {
    DatePicker,
    [Steps.name]: Steps,
    [Step.name]: Step
  },
  filters: {
    formatStatus(val) {
      if (val === 'NORMAL') {
        return 'status1';
      } else {
        return 'status2';
      }
    }
  },
  data() {
    return {
      workData: {},
      date: new Date(),
      fromDate: new Date(),
      dayInfo: {},
      attendances: [],
      attrs: [
        {
          dot: '#F2B230',
          dates: '2020-11-01T18:00:00Z'
        },
        {
          dot: 'indigo',
          dates: '2020-11-11T19:00:00Z'
        },
        {
          dot: 'indigo',
          dates: '2020-11-15T01:00:00Z'
        },
        {
          dot: 'red',
          dates: '2020-11-21T05:00:00Z'
        },
        {
          dot: 'green',
          dates: '2020-11-21T00:00:00Z'
        }
      ],
      unNormalList: [
        'LATE',
        'EARLY',
        'ABSENTEEISM',
        'LOST'
      ]
    };
  },
  created() {
    const year = moment().format('YYYY');
    const month = moment().format('MM');
    this.getList(year, month);
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getList(year, month) {
      const data = { year, month };
      attendanceList(data).then(res => {
        this.workData = res.data;
        this.attendances = res.data.attendances;
        res.data.attendances.forEach(item => {
          item.dates = moment(`${item.logDate} 19:00:00`).utc().format();
          item.dot = this.checkDot(item.infos);
        });
        const year = moment().format('YYYY');
        const month = moment().format('MM');
        if (data.year === year && data.month === month) {
          this.getDayInfo(moment().format('YYYY-MM-DD'));
        } else {
          this.dayInfo = {}
        }
      });
    },
    checkDot(list) {
      let next = false;
      list.forEach(item => {
        if (item.eventType === 'REST') {
          next = true;
        }
      });
      if (!next) {
        const data = list.filter(item => {
          return this.unNormalList.includes(item.eventType);
        });
        if (data.length > 0) {
          return 'orange';
        } else {
          return 'blue';
        }
      } else {
        return 'green';
      }
    },
    getDayInfo(day) {
      const attendances = this.attendances;
      const data = attendances.filter(item => {
        return item.logDate === day;
      });
      if (data.length > 0) {
        data[0].times = 0;
        data[0].infos && data[0].infos.forEach(item => {
          if (item.attendanceTime) {
            data[0].times++;
          }
        });
      }
      this.dayInfo = data.length > 0 ? data[0] : {};
    },
    dayclick(e) {
      const day = e.id;
      this.getDayInfo(day);
    },
    fromPage(e) {
      this.getList(e.year, e.month);
    },
    toPage(e) {
      this.getList(e.year, e.month);
    },
    getStatus(e) {
    }
  }
};
</script>

<style lang="less" scoped>
.attendanceRecord {
  padding: 0.145rem;
  .container {
    background-color: #ffffff;
    height: 280px;
    border: 1px solid #EFEFF4;
    box-shadow: 0px 3px 6px rgba(51, 51, 51, 0.1);
    opacity: 1;
    border-radius: 6px;
    .vc-container {
      --rounded-lg: 0rem;
      border: 1px solid #EFEFF4;
      box-shadow: 0px 3px 6px rgba(51, 51, 51, 0.1);
      opacity: 1;
      border-radius: 6px;
      height: 280px;
    }
  }
  .content {
    background: #FFFFFF;
    border: 1px solid #EFEFF4;
    box-shadow: 0px 3px 6px rgba(51, 51, 51, 0.1);
    opacity: 1;
    border-radius: 6px;
    margin-top: 0.08rem;
    padding: 0.07rem 0.18rem;
    .line {
      display: flex;
      justify-content: space-between;

      .item {
        display: flex;
        flex-direction: column;

        .up {
          display: flex;
          color: #3B86FF;
          .value {
            font-size: 0.2rem;
          }

          .tips {
            font-size: 0.12rem;
            margin-top: 0.085rem;
          }
        }

        .down {
          font-size: 0.12rem;
          font-weight: 400;
          line-height: 0.165rem;
          color: #333333;
          opacity: 1;
        }
      }
    }

    .rule {
      margin: 0.1rem 0;
      padding: 0.1rem 0;
      border-top: 1px solid #EFEFF4;
      border-bottom: 1px solid #EFEFF4;

      .value {
        font-size: 0.12rem;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 0.165rem;
        color: rgba(51, 51, 51, 0.7);
        opacity: 1;
      }
    }

    .details {
      padding: 0.085rem 0.185rem 0rem 0rem;

      .part {
        display: flex;
        padding-bottom: 0.165rem;
        margin-bottom: 0.05rem;
        margin-left: 0.09rem;

        .circleOut {
          margin-left: -0.105rem;
          width: 0.18rem;
          height: 0.18rem;
          background: #FFFFFF;
          border: 1px solid #3B86FF;
          border-radius: 50%;
          opacity: 1;
          display: flex;
          justify-content: center;
          align-items: center;

          .circleIn {
            width: 0.12rem;
            height: 0.12rem;
            background: #3B86FF;
            border: 1px solid #3B86FF;
            border-radius: 50%;
            opacity: 1;
          }

        }
      }

      .info {
        margin-left: 0.09rem;

        .header1 {
          display: flex;
          font-size: 0.15rem;
          font-weight: bold;
          line-height: 0.21rem;
          color: #333333;

          .status1 {
            background: rgba(255, 255, 255, 0.7);
            border: 2px solid #3B86FF;
            opacity: 1;
            border-radius: 0.135rem;
            font-size: 0.1rem;
            font-weight: 400;
            line-height: 0.1rem;
            color: #3B86FF;
            padding: 0.012rem 0.08rem;
            margin-left: 0.1rem;
            display: flex;
            align-items: center;
          }

          .status2 {
            background: rgba(255, 255, 255, 0.7);
            border: 2px solid #F2B230;
            opacity: 1;
            border-radius: 0.135rem;
            font-size: 0.1rem;
            font-weight: 400;
            line-height: 0.14rem;
            color: #F2B230;
            padding: 0.015rem 0.08rem;
            margin-left: 0.1rem;
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }
}
</style>
